import type { Site } from '../Site';

export const Thrifter: Site = {
  id: 'thrifter',
  analyticsName: 'thrifter',
  selector: '',
  logo: '',
  label: 'Thrifter',
  platform: '',
};
